module.exports = __webpack_public_path__ + "static/media/22.a471082e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/22.svg
// module id = 137
// module chunks = 0